exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom_button[data-v-3e661c0a] {\n  display: flex;\n  justify-content: right;\n  margin-top: 30px;\n}\n.error-message[data-v-3e661c0a] {\n  color: red;\n}\n", ""]);

// exports
